namespace $.$$ {

export class $shm_hitalama_method_runtime_view extends $.$shm_hitalama_method_runtime_view {

		@ $mol_mem
		runtime() {
			return new this.$.$shm_hitalama_method_runtime
		}

		template( next?: string ): string {
			if( next !== undefined ) {
				this.$.$mol_state_local.value( this + '.template', next )
				this.source( this.template_source( next ) )
				this.mock( this.mock_default( next ) )
				this.selected( '' )
				this.selected_view( '' )
				this.result( '' )
				return next
			}

			return this.$.$mol_state_local.value< string >( this + '.template' ) ?? '_app'
		}

		mock( next?: string ) {
			const template = this.template()
			const key = this + '.mock.' + template

			if( next !== undefined ) {
				this.$.$mol_state_local.value( key, next )
				this.selected( '' )
				this.selected_view( '' )
				this.result( '' )
				return next
			}

			const mock = this.$.$mol_state_local.value< string >( key )
			return this.mock_options()[ mock ?? '' ] !== undefined
				? mock ?? ''
				: this.mock_default( template )
		}

		mock_default( template: string ) {
			const ids = Object.keys( this.mock_options_for( template ) ).filter( Boolean )
			return ids[ 0 ] ?? ''
		}

		mock_options() {
			return this.mock_options_for( this.template() )
		}

		mock_options_for( template: string ) {
			const defaults = {
				'': 'Без мока',
			} as Record< string, string >

			switch( template ) {
				case '_ba':
					return {
						... defaults,
						'_ba.mock': 'BA CSV',
					}
				default:
					return defaults
			}
		}

		@ $mol_mem
		source( next?: string ): string {
			if( next !== undefined ) return next
			const source = this.runtime().source().source()
			if( source.trim() ) return source
			return this.template_source( this.template() )
		}

		@ $mol_mem
		mock_source( next?: string ): string {
			if( next !== undefined ) return next
			const mock = this.mock()
			return mock ? this.template_mock_source( mock ) : ''
		}

		source_text( next?: string ) {
			const source_method = this.source_method()
			if( !source_method ) return this.source( next )

			const methods = this.methods()
			const index = methods.findIndex( method => method.name === source_method )
			if( index === -1 ) {
				this.source_method( '' )
				return this.source( next )
			}

			if( next !== undefined ) {
				const changed = methods.map( method => ({ ... method }) )
				changed[ index ].code = next
				this.source( changed.map( method => this.runtime().source().source_method( method ) ).join( '\n\n' ) + '\n' )
				return next
			}

			return methods[ index ].code
		}

		template_uri( id: string ) {
			return $shm_hitalama_ghpages_fix_link( `shm/hitalama/method/templates/${ id }.js` )
		}

		template_source( id: string ) {
			return this.$.$mol_fetch.text( this.template_uri( id ) )
		}

		template_mock_uri( id: string ) {
			return $shm_hitalama_ghpages_fix_link( `shm/hitalama/method/templates/${ id }.js` )
		}

		template_mock_source( id: string ) {
			return this.$.$mol_error_fence(
				()=> this.$.$mol_fetch.text( this.template_mock_uri( id ) ),
				()=> '',
			)
		}

		methods() {
			return [
				... this.runtime().source().parse( this.source() ),
				... this.runtime().source().parse( this.mock_source() ),
			]
		}

		@ $mol_mem
		app() {
			return this.runtime().app_make( this.methods() )
		}

		method_ids() {
			return this.methods().map( method => method.name )
		}

		method_title( id: string ) {
			const method = this.methods().find( item => item.name === id )
			if( !method ) return id
			return `${ method.name }( ${ method.args } )`
		}

		method_view( id: string ) {
			const method = this.methods().find( item => item.name === id )
			return method?.decorator === 'view' || method?.decorator === 'view_key'
		}

		selected( next?: string ) {
			const key = this + '.selected'
			if( next !== undefined ) {
				this.$.$mol_state_local.value( key, next )
				return next
			}

			const selected = this.$.$mol_state_local.value< string >( key ) ?? ''
			if( !selected ) return ''
			return this.methods().some( method => method.name === selected ) ? selected : ''
		}

		source_method( next?: string ) {
			const key = this + '.source_method'
			if( next !== undefined ) {
				this.$.$mol_state_local.value( key, next )
				return next
			}

			const source_method = this.$.$mol_state_local.value< string >( key ) ?? ''
			if( !source_method ) return ''
			return this.methods().some( method => method.name === source_method ) ? source_method : ''
		}

		preview_title() {
			const id = this.selected()
			return id ? this.method_title( id ) : 'Превью метода'
		}

		method_run( id: string, event?: Event ) {
			event?.preventDefault()
			this.selected( id )
			this.method_result( id )
		}

		method_focus( id: string, next?: boolean ) {
			if( next !== undefined ) {
				this.source_method( next ? id : '' )
				return next
			}

			return this.source_method() === id
		}

		arg_default( id: string ) {
			const method = this.methods().find( item => item.name === id )
			switch( method?.decorator ) {
				case 'action':
				case 'none':
					return {}
				case 'view':
					return undefined
				case 'view_key':
				case 'mem_key':
					return ''
				default:
					return undefined
			}
		}

		result_string( value: any ) {
			if( value instanceof $mol_view ) return ''
			if( typeof value === 'string' ) return value
			if( value === undefined ) return 'undefined'
			return JSON.stringify( value, null, '\t' ) ?? String( value )
		}

		result_sub() {
			const value = this.result_value()
			if( value instanceof $mol_view ) return [ value ]
			return [ this.Result_text() ]
		}

		result_value() {
			const id = this.selected()
			if( !id ) return null
			const result = this.method_result( id )
			if( result.error ) return null
			return result.value
		}

		result_text() {
			const id = this.selected()
			if( !id ) return ''
			const result = this.method_result( id )
			if( result.error ) return this.$.$mol_error_message( result.error )
			return this.result_string( result.value )
		}

		@ $mol_mem_key
		method_result( id: string ) {
			const method = this.methods().find( item => item.name === id )
			if( !method ) return { value: null, error: new Error( `Method "${ id }" not found` ) }
			const func = this.app()[ id ]
			if( typeof func !== 'function' ) return { value: null, error: new Error( `Method "${ id }" is not a function` ) }

			try {
				const value = func( this.arg_default( id ) )
				return { value, error: null as any }
			} catch( error ) {
				return { value: null, error }
			}
		}

	}

	export class $shm_hitalama_method_runtime_view_methods extends $.$shm_hitalama_method_runtime_view_methods {

		item_current( id: string ) {
			return this.selected() === id
		}

	}

}
